const ENV_VAR = process.env.VUE_APP_ENV;

export const shareConfig = {
    SHARE_NAME : "spider-onepage-h5",
    // GZH_OPENID : ENV_VAR === "prod" ? "gh_fbfcaabc1843" : "gh_6c8cb8574d9f",  // 公众号openid
    // WMT_URL    : ENV_VAR === "prod" ? "https://wmt.maxuscloud.com/" : "https://wmtt4.maxuscloud.cn/",  // wmt请求地址
    GZH_OPENID : "gh_fbfcaabc1843",  // 公众号openid
    WMT_URL    : "https://wmt.maxuscloud.com/",  // wmt请求地址
};
